$('document').ready(function(){
	$(window).on('load', function() {
		//hideLoader();
	});

	hideLoader();

	function hideLoader() {
		$('.page-loader').fadeOut();
		console.log('loaded');
	}

	// Hamburger
	$('html').on('click', '.hamburger', function(event){
		event.preventDefault();
		if($(this).attr('aria-expanded')=='false') {
			$(this).attr('aria-expanded', 'true');
			$(this).addClass('is-active');
			$('.slidenav').fadeIn();
		} else {
			$(this).attr('aria-expanded', 'false');
			$(this).removeClass('is-active');
			$('.slidenav').fadeOut();
		}
	});

	if ( $(window).scrollTop() > 0) {
		$('.header').addClass('sticky');
	}
	$(window).scroll(function() {
		let scroll = $(window).scrollTop();
		if (scroll > 0) {
			$('.header').addClass('sticky');
		} else {
			$('.header').removeClass('sticky');
		}
	});


	// Parallax
	// Use 'data-speed' 0.0 to 1.0 for distance
	// Use 'data-direction' up or down for direction
	let parallaxElems = $("[data-speed]");

	$(parallaxElems).each(function () {
		let directionInit;
		let directionFinal;

		if (this.getAttribute("data-direction") == "up") {
			directionInit = -1;
			directionFinal = 1;
		} else if (this.getAttribute("data-direction") == "down") {
			directionInit = 1;
			directionFinal = -1;
		}

		gsap.to(this, {
			y: (i, el) =>
			directionInit * parseFloat(el.getAttribute("data-speed")) * this.offsetHeight
		});

		gsap.to(this, {
			y: (i, el) =>
			directionFinal *
			parseFloat(el.getAttribute("data-speed")) *
			this.offsetHeight,
			ease: "none",
			scrollTrigger: {
				trigger: this,
				start: "top bottom",
				end: "bottom top",
				invalidateOnRefresh: true,
				scrub: 0,
				markers: false
			}
		});
	});

	// BG Parallax
	let getRatio = el => window.innerHeight / (window.innerHeight + el.offsetHeight);

	gsap.utils.toArray(".bg-parallax").forEach((section, i) => {

		gsap.fromTo(section, {
			backgroundPosition: () => i ? `50% ${-window.innerHeight * getRatio(section)}px` : "50% 0px"
		}, {
			backgroundPosition: () => `50% ${window.innerHeight * (1 - getRatio(section))}px`,
			ease: "none",
			scrollTrigger: {
				trigger: section,
				start: () => i ? "top bottom" : "top top",
				end: "bottom top",
				scrub: true,
				invalidateOnRefresh: true
			}
		});
	});

	// Token info
	$('.token-info')
	.mouseover(function() {
		$(this).addClass('hover');
	})
	.mouseout(function() {
		$(this).removeClass('hover');
	});

	$('html').on('click', '.token-pull', function(event){
		event.preventDefault();
		if($('.token-info').hasClass('active')) {
			$('.token-overlay').removeClass('active');
			$('.token-info').removeClass('active');
		} else {
			$('.token-info').addClass('active');
			$('.token-overlay').addClass('active');
		}
	});

	$('html').on('click', '.token-overlay', function(event){
		event.preventDefault();
		$(this).removeClass('active');
		$('.token-info').removeClass('active');
	});

	function playVid(iframe) {
		let player = new Vimeo.Player(iframe);

		player
		.play()
		.then(function () {})
		.catch((error) => {});

		player
		.setCurrentTime(0)
		.then(function (seconds) {})
		.catch((error) => {});
	}

	function pauseVid(iframe) {
		let player = new Vimeo.Player(iframe);
		player
		.pause()
		.then(function () {})
		.catch((error) => {});
	}

	$('.flex-panel').each(function() {
		if ($(this).find('.vid-fluid').length) {
			let vidFrame = $(this).find('.vid-fluid iframe');
			ScrollTrigger.create({
				trigger: $(this),
				start: "top bottom",
				end: "bottom top",
				onEnter: () => playVid(vidFrame),
				onEnterBack: () => playVid(vidFrame),
				onLeave: () => pauseVid(vidFrame),
				markers: false
			});
		};
	});

	$(window).on('load', function() {
		gsap.utils.toArray('.timeline-box').forEach(quarter => {
			let quarterDiv = document.querySelector("#quarter");
			let yearDiv = document.querySelector("#year");
			let quarterN = $(quarter).data('quarter');
			let yearN = $(quarter).data('year');

			ScrollTrigger.create({
				trigger: quarter,
				start: "top center",
				end: "bottom center",
				markers: false,
				onEnter: self => updateDate(),
				onEnterBack: self => updateDate(),
			});

			function updateDate() {
				yearDiv.innerText = yearN,
				quarterDiv.innerText = quarterN
			}
		});
	});

	// Copy to Clipboard
	async function copyTargetText(e) {
		try {
			await navigator.clipboard.writeText(e.target.innerText);
		} catch (err) {
			console.error("Failed to copy: ", err);
		}
	}

	$(".copy-text").on("click", function (e) {
		e.preventDefault();
		copyTargetText(e);
		$(this).parent().find(".copied").fadeIn().delay(1000).fadeOut();
	});

	// Utility Bar
	let utilityBar = $(".utility-bar");
	let utilitySize = $(utilityBar).find(".content").outerWidth();

	function utilityRecalc(newSize) {
		$(utilityBar).css("right", -newSize);
	}
	utilityRecalc(utilitySize);

	$(window).resize(function () {
		let utilitySize = $(utilityBar).find(".content").outerWidth();
		utilityRecalc(utilitySize);
	});
	
	$(utilityBar).find('.tab').on("click", () => {
		$(utilityBar).toggleClass("open");
	});

	$(utilityBar).click(() => {
		event.stopPropagation();
	});

	$(window).on('click', () => {
		if($(utilityBar).hasClass('open')) {
			$(utilityBar).removeClass('open');
		}
	});

	// Header Strip
	if($('#headerStrip').length > 0) {
		let headerStrip = $("#headerStrip");
		let stripSize = $(headerStrip).outerHeight();

		function stripRecalc(newSize) {
			$('.header').css("top", newSize);
		}
		stripRecalc(stripSize);

		$(window).resize(function () {
			let stripSize = $(headerStrip).outerHeight();
			stripRecalc(stripSize);
		});
	}
});